import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from "react";
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom2.css';

import SweetAlert from 'react-bootstrap-sweetalert';

import axios from 'axios'


import { MultiSelect } from "react-multi-select-component";
import { API_BASE_PATH } from './Api';


import styled from "styled-components";
import JobsTable from './table/JobsTable';

const Input = styled.input.attrs(props => ({
  type: props.type=="password"?"password":"text",
  size: props.small ? 5 : undefined
}))`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;
`;


const Jobs = () => {

  const [loading, setLoading] = useState(false);
  var userInfo = localStorage.getItem("userInfo");
  if (userInfo) {
    userInfo = JSON.parse(userInfo);
  }




  const loginId = userInfo?.loginId;

  

  

  return (
    <>

      
      {
        <div style={{ height: "100%" }}>
          <div style={{ width: "80%" }} className="py-4 mx-auto mt-5">
          {loading && <h2>Loading.........</h2>}

               
          <JobsTable/>
          </div>
        </div>
      }

    </>
  );
};
export default Jobs;

